module.exports = __webpack_public_path__ + "assets/img/Logitech-G-Global-Landing-Page-w960.a563307f.jpg";